
 <div >
   <div >
          <div class="header">
            <div class="rowFix" >
              <div class="col-md">
                <h3>{{'DASHBOARD.TITLE' | translate}}</h3>
              </div>
              <div style="width: 20%; padding-right: 15px;">
                  <p-dropdown
                    class="dv-dropdown"
                    selectId="company"
                    [options]="company"
                    [(ngModel)]="selectedCompany"
                    [autoDisplayFirst]="false"
                    placeholder="{{'FILTER.COMPANY' | translate}}"
                    (onChange)="loadMonthlyData()"
                  >
                  </p-dropdown>
              </div>
              <div >
                  <p-dropdown
                    class="dv-dropdown"
                    selectId="year"
                    [options]="yearList"
                    [(ngModel)]="selectedYear"
                    [autoDisplayFirst]="false"
                    placeholder="ปี"
                    (onChange)="loadMonthlyData()"
                  >
                  </p-dropdown>
              </div>
            </div>
          </div>

      <div class="box-parent scrollable" style="height: calc(100vh - 2.25rem - 150px);">
        <canvas id="signing-counter-bar-chart">{{ charts_signing_counter_bar_stacked }}</canvas>
      </div>
   </div>

</div>



// WEBPACK FOOTER //
// /opt/app/src/app/features/dashboard/dashboard-document/dashboard-document.component.html